export default __webpack_public_path__ + "static/media/grayTiktok.f82fc89b.svg";